export const CartActionType = {
    SelectedCart: '[Cart] Selected Cart',
    SetOrderPayment: '[Common] Set list order payment request'
};